import React, { PureComponent, Fragment } from 'react';
import { bool, string, shape } from 'prop-types';
import classnames from 'classnames';
import './Image.scss';

export default class Image extends PureComponent {
    static propTypes = {
        src: string,
        alt: string,
        className: string,
        classNames: shape({
            lazyload: string,
        }),
        lazyload: bool,
        cdn: shape({
            CDN_IMAGE: string,
        }).isRequired,
    };

    static defaultProps = {
        src: '',
        alt: '',
        className: '',
        lazyload: false,
        classNames: {
            lazyload: 'lazyload',
        },
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.src !== prevState.imageToLoad) {
            return {
                imageToLoad: nextProps.src,
                loading: prevState.imageToLoad !== null,
            };
        }
        return null;
    }

    state = {
        imageToLoad: null,
        loading: false,
    };

    componentDidUpdate() {
        if (this.state.loading) {
            const tmpImg = new window.Image();

            tmpImg.onload = () => {
                this.setState({
                    loading: false,
                });
            };
            tmpImg.src = this.state.imageToLoad;
        }
    }

    render() {
        const {
            src,
            alt,
            className,
            lazyload,
            cdn,
            classNames,
            ...otherProps
        } = this.props;
        const { loading } = this.state;
        const rootClassnames = classnames(className, {
            [classNames.lazyload]: lazyload,
        });
        const image = src || `${cdn.CDN_IMAGE}/placeholder.svg`;

        return (
            <Fragment>
                {loading ? (
                    <img
                        alt={alt}
                        className={rootClassnames}
                        src={`${cdn.CDN_IMAGE}/placeholder.svg`}
                    />
                ) : (
                    <img
                        {...otherProps}
                        alt={alt}
                        className={rootClassnames}
                        src={
                            lazyload
                                ? `${cdn.CDN_IMAGE}/placeholder.svg`
                                : image
                        }
                        data-src={image}
                    />
                )}
            </Fragment>
        );
    }
}
